import React from 'react';

import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceInputProps,
  required,
} from 'react-admin';

interface AutocompleteClientInputProps
  extends Omit<ReferenceInputProps, 'reference' | 'filterToQuery'> {
  isRequired?: boolean;
  size?: 'small' | 'medium';
}

const AutocompleteClientInput: React.FC<AutocompleteClientInputProps> = ({
  source,
  label,
  filter,
  isRequired,
  size,
  ...props
}) => (
  <ReferenceInput
    {...props}
    source={source}
    filter={filter}
    reference="Client"
    filterToQuery={(name: string) => ({
      name,
    })}
  >
    <AutocompleteInput
      optionText="name"
      filter="name"
      label={label}
      size={size}
      validate={isRequired ? required('Client is required') : undefined}
    />
  </ReferenceInput>
);

export default AutocompleteClientInput;
